/* /decks — the community deck browser, in the browser.
 * The page arrives server-rendered (first page of decks as real links). From the first interaction on,
 * search, format chips, sorting and "show more" run here from the cached deck index (/deck-index.php):
 * no Firestore reads, no reloads, and the URL keeps the state so every view can be shared.
 * The matching and tile markup mirror pages/decks.php + inc/ktm-decks.php exactly.
 */
import "../lib/site.js";

(function () {
  "use strict";

  var KD = window.KD, esc = KD.esc;
  var PER = 24;
  var grid = KD.$("[data-grid]"), pager = KD.$("[data-pager]");
  if (!grid || !pager) return;

  var FORMAT_LABELS = { commander: "Commander", standard: "Standard", modern: "Modern", pioneer: "Pioneer", legacy: "Legacy", vintage: "Vintage", pauper: "Pauper",
    historic: "Historic", alchemy: "Alchemy", brawl: "Brawl", explorer: "Explorer", timeless: "Timeless", standardbrawl: "Standard Brawl", "1v1commander": "1v1 Commander",
    oathbreaker: "Oathbreaker", premodern: "Premodern", duel: "Duel Commander", paupercommander: "Pauper Commander", penny: "Penny Dreadful", gladiator: "Gladiator", predh: "PreDH", casual: "Casual" };
  var COLOR_WORDS = { white: "W", blue: "U", black: "B", red: "R", green: "G",
    azorius: "WU", dimir: "UB", rakdos: "BR", gruul: "RG", selesnya: "GW", orzhov: "WB", izzet: "UR", golgari: "BG", boros: "RW", simic: "GU",
    esper: "WUB", grixis: "UBR", jund: "BRG", naya: "RGW", bant: "GWU", abzan: "WBG", jeskai: "URW", sultai: "BGU", mardu: "RWB", temur: "GUR" };

  function norm(f) {
    f = String(f || "").trim().toLowerCase();
    if (["commander", "edh", "commander/edh", "commander / edh", "cmdr"].indexOf(f) !== -1) return "commander";
    return f.replace(/[^a-z0-9]+/g, "");
  }
  function label(f) { return FORMAT_LABELS[f] || (f ? f.charAt(0).toUpperCase() + f.slice(1) : "Casual"); }
  function sameColors(a, b) { return a.split("").sort().join("") === b.split("").sort().join(""); }
  function art(img) { return img ? (img.charAt(0) === "~" ? "https://cards.scryfall.io/art_crop/" + img.slice(1) : img) : ""; }

  var params = new URLSearchParams(location.search);
  var st = {
    q: (params.get("q") || "").trim(),
    format: norm(params.get("format") || ""),
    sort: ["views", "likes", "name"].indexOf(params.get("sort")) !== -1 ? params.get("sort") : "new",
    list: null,
    next: 0
  };
  var startPage = Math.max(1, parseInt(params.get("page"), 10) || 1);
  var index = null, full = false, pending = null;

  // /deck-index.php: without snippets for browsing, with them once someone searches
  function load(needFull) {
    if (index && (full || !needFull)) return Promise.resolve(index);
    if (pending && (pending.full || !needFull)) return pending.p;
    var p = fetch("/deck-index.php" + (needFull ? "?full=1" : ""), { credentials: "omit" })
      .then(function (r) { if (!r.ok) throw new Error("index " + r.status); return r.json(); })
      .then(function (j) { index = (j.decks || []).filter(function (d) { return !d.j; }); if (needFull) full = true; return index; });
    pending = { p: p, full: needFull };
    p.catch(function () { pending = null; });
    return p;
  }

  function matches(d, words) {
    var hay = (d.n + " " + (d.c || "") + " " + (d.p || "") + " " + (d.a || "") + " " + label(d.f) + " " + (d.s || "")).toLowerCase();
    var score = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i], cw = COLOR_WORDS[w];
      if (cw && d.k && (cw.length === 1 ? d.k.indexOf(cw) !== -1 : sameColors(d.k, cw))) { score += 2; continue; }
      if (hay.indexOf(w) === -1) return 0;
      score += d.n.toLowerCase().indexOf(w) !== -1 ? 6 : ((d.c || "") + " " + (d.p || "")).toLowerCase().indexOf(w) !== -1 ? 5 : 1;
    }
    return score;
  }

  function compute() {
    var list = index.slice();
    if (st.format) list = list.filter(function (d) { return d.f === st.format; });
    if (st.q) {
      var words = st.q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
      list = list.map(function (d) { return { d: d, s: words.length ? matches(d, words) : 1 }; })
        .filter(function (x) { return x.s > 0; })
        .map(function (x) { x.d._s = x.s; return x.d; });
    }
    list.sort(function (a, b) {
      if (st.q && st.sort === "new" && a._s !== b._s) return b._s - a._s;
      if (st.sort === "views") return (b.v - a.v) || (b.t - a.t);
      if (st.sort === "likes") return (b.h - a.h) || (b.v - a.v);
      if (st.sort === "name") return a.n.localeCompare(b.n, undefined, { sensitivity: "base" });
      return b.t - a.t;
    });
    return list;
  }

  function tile(d) {
    var img = KD.safeUrl(art(d.img));
    var who = d.c ? d.c + (d.p ? " + " + d.p : "") : "";
    return '<a class="dcard dtile" href="/deck-view?deckId=' + encodeURIComponent(d.i) + '">' +
      '<div class="dcard__art">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '<span class="mark"><svg viewBox="0 0 64 64" aria-hidden="true"><use href="#mark"/></svg></span>') +
        '<div class="dcard__badges"><span class="badge">' + esc(label(d.f)) + "</span>" + (d.ar ? '<span class="badge badge--glow">Arena</span>' : "") + "</div></div>" +
      '<div class="dcard__body"><h3 class="dcard__name">' + esc(d.n) + "</h3>" +
        (who ? '<p class="dtile__cmd"><span class="pips">' + KD.colorPips((d.k || "").split("")) + "</span><span>" + esc(who) + "</span></p>" : "") +
        '<div class="dcard__meta"><span class="dtile__by">' + (d.a ? "by " + esc(d.a) : "") + "</span>" +
        '<span class="dtile__stats">' + KD.icon("eye") + KD.fmt(d.v) + " " + KD.icon("heart") + KD.fmt(d.h) + "</span></div></div></a>";
  }

  function countText(n) {
    if (st.q) return KD.fmt(n) + " " + (n === 1 ? "deck matches" : "decks match") + " “" + st.q + "”";
    return KD.fmt(n) + " " + (st.format ? label(st.format) + " " : "") + (n === 1 ? "deck" : "decks");
  }

  function more() {
    var slice = st.list.slice(st.next, st.next + PER);
    grid.insertAdjacentHTML("beforeend", slice.map(tile).join(""));
    st.next += slice.length;
    pager.innerHTML = st.next < st.list.length ? '<button class="btn btn--ghost" type="button" data-more>Show more decks <small class="muted">' + KD.fmt(st.list.length - st.next) + " left</small></button>" : "";
  }

  function syncUrl() {
    var p = new URLSearchParams();
    if (st.q) p.set("q", st.q);
    if (st.format) p.set("format", st.format);
    if (st.sort !== "new") p.set("sort", st.sort);
    history.replaceState(null, "", "/decks" + (p.toString() ? "?" + p : ""));
  }

  function syncChips() {
    KD.$$("[data-f]").forEach(function (a) { a.classList.toggle("is-on", a.getAttribute("data-f") === st.format); });
    var first = KD.$('[data-sort] option[value="new"]');
    if (first) first.textContent = st.q ? "Best match" : "Newest";
  }

  var busy = false;
  function apply(opts) {
    opts = opts || {};
    if (busy) return;
    busy = true;
    grid.setAttribute("aria-busy", "true");
    grid.classList.add("is-loading");
    load(!!st.q).then(function () {
      st.list = compute();
      st.next = 0;
      grid.innerHTML = st.list.length ? "" : '<div class="empty" style="grid-column:1/-1">' + KD.icon("search") +
        "<h3>No decks match that</h3><p>Try a commander's name, a card, or a strategy like “tokens” or “reanimator”.</p>" +
        '<button class="btn btn--ghost" type="button" data-reset>Show all decks</button></div>';
      if (st.list.length) more(); else pager.innerHTML = "";
      KD.$("[data-count]").textContent = countText(st.list.length);
      syncChips();
      syncUrl();
      if (opts.scroll) KD.$("[data-formats]").scrollIntoView({ behavior: KD.reduce ? "auto" : "smooth", block: "start" });
      KD.ga("decks_filter", { q: st.q ? 1 : 0, format: st.format || "all", sort: st.sort });
    }).catch(function () {
      KD.toast("Couldn't load the deck library. Check your connection and try again.", "err");
    }).then(function () { busy = false; grid.removeAttribute("aria-busy"); grid.classList.remove("is-loading"); });
  }

  // ---- wiring (the server-rendered links keep working without JavaScript)
  var form = KD.$("[data-search]"), qInput = KD.$("[data-q]"), sortSel = KD.$("[data-sort]");
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    st.q = qInput.value.trim();
    if (KD.mobile()) qInput.blur();
    apply({ scroll: true });
  });
  qInput.addEventListener("input", function () { if (!qInput.value.trim() && st.q) { st.q = ""; apply(); } });
  qInput.addEventListener("focus", function () { load(true).catch(function () {}); }, { once: true });
  sortSel.addEventListener("change", function () { st.sort = sortSel.value; apply(); });
  KD.$("[data-formats]").addEventListener("click", function (e) {
    var a = e.target.closest("[data-f]");
    if (!a) return;
    e.preventDefault();
    st.format = a.getAttribute("data-f");
    apply();
  });
  grid.addEventListener("click", function (e) { if (e.target.closest("[data-reset]")) { st.q = ""; st.format = ""; qInput.value = ""; apply(); } });
  pager.addEventListener("click", function (e) {
    var b = e.target.closest("[data-more]");
    if (!b) return;
    e.preventDefault();
    if (st.list) { more(); return; }
    // first "show more": pick up from what the server rendered
    b.classList.add("is-busy");
    load(!!st.q).then(function () {
      st.list = compute();
      st.next = Math.min(st.list.length, startPage * PER); // continue after the page the server rendered
      more();
      if (startPage > 1) { startPage = 1; syncUrl(); }
    }).catch(function () {
      b.classList.remove("is-busy");
      KD.toast("Couldn't load more decks. Check your connection and try again.", "err");
    });
  });

  // warm the index once the page is idle, so the first click is instant
  (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(function () { load(!!st.q).catch(function () {}); });
})();
